<mat-card class="reenvios-dialog">
  <app-card-header
    [title]="'Reglas de reenvío'"
    [subtitle]="data.nombreEntidad"
    icono="rule"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @for (fila of filas; track $index) {
      <app-content-card
        [title]="fila.metodo"
        [icon]="fila.icono"
        [class.rtd-no-vigente]="!fila.vigente"
      >
        <div card-header-actions class="rtd-acciones">
          <span class="rtd-estado" [class.rtd-vigente]="fila.vigente">
            {{ fila.vigente ? 'Vigente' : 'No vigente' }}
          </span>
          @if (fila.ajustable) {
            <button
              irxBotonIcono
              type="button"
              tono="primario"
              tooltip="Ajustar o detener la emergencia"
              (click)="ajustar(fila)"
            >
              <mat-icon>tune</mat-icon>
            </button>
          }
        </div>

        <div class="rtd-datos">
          @if (fila.destino) {
            <span class="rtd-etiqueta">Destino</span>
            <span class="rtd-valor">{{ fila.destino }}</span>
          }
          @if (fila.protocolo) {
            <span class="rtd-etiqueta">Protocolo</span>
            <span class="rtd-valor">{{ fila.protocolo }}</span>
          }
          @if (fila.agrupacion) {
            <span class="rtd-etiqueta">Agrupación</span>
            <span class="rtd-valor">{{ fila.agrupacion }}</span>
          }
          @if (fila.entidad) {
            <span class="rtd-etiqueta">Entidad reenviada</span>
            <span class="rtd-valor">{{ fila.entidad }}</span>
          }
          @if (fila.clienteReenvio) {
            <span class="rtd-etiqueta">Cliente de reenvío</span>
            <span class="rtd-valor">
              {{ fila.clienteReenvio }}
              @if (fila.reenviarHijos) {
                (incluye clientes hijos)
              }
            </span>
          } @else if (fila.reenviarHijos) {
            <span class="rtd-etiqueta">Clientes hijos</span>
            <span class="rtd-valor">Incluidos</span>
          }
          @if (fila.fechaCreacion) {
            <span class="rtd-etiqueta">Creada</span>
            <span class="rtd-valor">{{ fila.fechaCreacion }}</span>
          }
          @if (fila.periodo) {
            <span class="rtd-etiqueta">Período</span>
            <span class="rtd-valor">{{ fila.periodo }}</span>
          }
        </div>

        @if (fila.reglas.length) {
          <table class="rtd-reglas">
            <thead>
              <tr>
                <th>Puerto entrada</th>
                <th>Protocolo</th>
                <th>Host salida</th>
                <th>Puerto salida</th>
                <th>Protocolo</th>
              </tr>
            </thead>
            <tbody>
              @for (regla of fila.reglas; track $index) {
                <tr>
                  <td>
                    @if (regla.puertoEntrada != null) {
                      {{ regla.puertoEntrada }}
                    } @else {
                      <span class="no-info">Sin información</span>
                    }
                  </td>
                  <td>
                    @if (regla.protocoloEntrada != null) {
                      {{ regla.protocoloEntrada }}
                    } @else {
                      <span class="no-info">Sin información</span>
                    }
                  </td>
                  <td>
                    @if (regla.hostSalida != null) {
                      {{ regla.hostSalida }}
                    } @else {
                      <span class="no-info">Sin información</span>
                    }
                  </td>
                  <td>
                    @if (regla.puertoSalida != null) {
                      {{ regla.puertoSalida }}
                    } @else {
                      <span class="no-info">Sin información</span>
                    }
                  </td>
                  <td>
                    @if (regla.protocoloSalida != null) {
                      {{ regla.protocoloSalida }}
                    } @else {
                      <span class="no-info">Sin información</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </app-content-card>
    } @empty {
      <p class="no-info rtd-vacio">
        No hay configuraciones de reenvío para esta entidad
      </p>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
